// Vue 3 bootstrap (KAT-943 Phase 2b). `createApp` replaces `new Vue({ el, ... })`; plugin/global
// component registration now happens on the app instance instead of the `Vue` constructor.
import { createApp, watch } from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/style/style.scss'
import Icon from '@/elements/Icon'

import 'es6-shim'
import 'custom-event-polyfill'
import '@/config/axios'

// Moment — `moment/locale/nb` is a side-effecting import (moment's `defineLocale` also sets it
// as the active global locale for every `moment()` call app-wide, in every file), so it stays
// even though the `vue-moment` filter plugin — which only ever wrapped `moment` for the
// template `| moment(...)` filter syntax Vue 3 removed entirely — is gone. Other files call
// `moment(...).format(...)` directly now (see PageDrawTab.vue, AudioListItem.vue).
import 'moment/locale/nb'

const app = createApp(App)

app.use(store)
app.use(router)

// Replaces `vuex-router-sync` (no stable Vue 3 release — see src/store/modules/route.js for
// the full rationale): mirrors the current route into the Vuex `route` module on every
// navigation, since `store/modules/book.js`'s `currentPageNumber` getter reads
// `rootState.route.params.pageNumber`.
watch(
  () => router.currentRoute.value,
  (route) => store.commit('UPDATE_ROUTE', route),
  { immediate: true }
)

app.component('t-icon', Icon)

app.mount('#app')
